import React from 'react';

interface BenefitItemProps {
  icon: React.ReactNode;
  text: string;
}

const BenefitItem: React.FC<BenefitItemProps> = ({ icon, text }) => {
  return (
    <div className="flex items-center bg-dark-light rounded-lg p-4 mb-6">
      <div className="mr-6 text-primary">
        {icon}
      </div>
      <p className="text-white text-lg">{text}</p>
    </div>
  );
};

const TimeIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4l3 3m6-3a9 9 0 11-18 0 9 9 0 0118 0z" />
  </svg>
);

const TargetIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
  </svg>
);

const ReturnIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" className="h-8 w-8" fill="none" viewBox="0 0 24 24" stroke="currentColor">
    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M16 15v-1a4 4 0 00-4-4H8m0 0l3 3m-3-3l3-3m9 14V5a2 2 0 00-2-2H6a2 2 0 00-2 2v16l4-2 4 2 4-2 4 2z" />
  </svg>
);

const BenefitsList: React.FC = () => {
  return (
    <section className="bg-dark py-20 px-4">
      <div className="max-w-6xl mx-auto">
        <div className="grid md:grid-cols-2 gap-12">
          <div>
            <h2 className="text-4xl font-bold text-gray-300 mb-12">
              Unlock Growth and Efficiency
            </h2>
          </div>
          
          <div>
            <BenefitItem 
              icon={<TimeIcon />}
              text="Reduced refund processing time"
            />
            
            <BenefitItem 
              icon={<TargetIcon />}
              text="Reduce refund-related support by up to 50% so you can focus on growth"
            />
            
            <BenefitItem 
              icon={<ReturnIcon />}
              text="Enhanced overall ROI with optimized post-purchase strategies"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BenefitsList;